<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block" [class.component-dark-theme]="isToggled">
  <mat-card-header>
    <mat-card-title>
      <h5 class="mb-0">{{ notification.title }}</h5>
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <p><strong>Datum poruke:</strong> {{ notification.createdOn | date: 'd.M.yyyy.' }}</p>
    <p>{{ notification.message }}</p>

    @if (notificationFiles && notificationFiles.length > 0) {
      <p><strong>Priložene datoteke:</strong></p>
      <ul>
        @for (file of notificationFiles; track file) {
          <li>
            <a (click)="downloadFile(file)" class="download-link">
              {{ file.name }}
            </a>
          </li>
        }
      </ul>
    }
  </mat-card-content>
</mat-card>